import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetActivitiesById = createAsyncThunk(
  "GetActivitiesById/GetActivitiesById",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Activities/GetActivitiesById",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteActivities = createAsyncThunk(
  "DeleteActivities/DeleteActivities",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Activities/DeleteActivities",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateActivities = createAsyncThunk(
  "UpdateActivities/UpdateActivities",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Activities/UpdateActivities",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddActivities = createAsyncThunk(
  "AddActivities/AddActivities",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Activities/AddActivities",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const Activities = createSlice({
  name: "Activities",
  initialState: {
    Activities: {},
    loadingActivities: false,
    errorActivities: null,

    AddActivities: {},
    loadingAddActivities: false,
    errorAddActivities: null,

    UpdateActivities: {},
    loadingUpdateActivities: false,
    errorUpdateActivities: null,

    DeleteActivities: {},
    loadingDeleteActivities: false,
    errorDeleteActivities: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetActivitiesById.pending, (state, action) => {
        state.loadingActivities = true;
        state.Activities = action.payload;
        state.errorActivities = null;
      })
      .addCase(GetActivitiesById.fulfilled, (state, action) => {
        state.loadingActivities = false;
        state.Activities = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetActivitiesById.rejected, (state, action) => {
        state.loadingActivities = false;
        state.errorActivities = action.payload;
      })

      .addCase(DeleteActivities.pending, (state, action) => {
        state.loadingDeleteActivities = true;
        state.DeleteActivities = action.payload;
        state.errorDeleteActivities = null;
      })
      .addCase(DeleteActivities.fulfilled, (state, action) => {
        state.loadingDeleteActivities = false;
        state.DeleteActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteActivities.rejected, (state, action) => {
        state.loadingDeleteActivities = false;
        state.errorDeleteActivities = action.payload;
      })

      .addCase(UpdateActivities.pending, (state, action) => {
        state.loadingUpdateActivities = true;
        state.UpdateActivities = action.payload;
        state.errorUpdateActivities = null;
      })
      .addCase(UpdateActivities.fulfilled, (state, action) => {
        state.loadingUpdateActivities = false;
        state.UpdateActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateActivities.rejected, (state, action) => {
        state.loadingUpdateActivities = false;
        state.errorUpdateActivities = action.payload;
      })

      .addCase(AddActivities.pending, (state, action) => {
        state.loadingAddActivities = true;
        state.AddActivities = action.payload;
        state.errorAddActivities = null;
      })
      .addCase(AddActivities.fulfilled, (state, action) => {
        state.loadingAddActivities = false;
        state.AddActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddActivities.rejected, (state, action) => {
        state.loadingAddActivities = false;
        state.errorAddActivities = action.payload;
      });
  },
});

export default Activities.reducer;
